/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Header, BrandColors, Tag } from '@blend/enterprise-components';
export namespace Tab {
  export interface Props {
    id: string;
    label: string;
    active: boolean;
    count?: number;
    onClick?: () => void;
    href?: string;
  }
}

const styles = StyleSheet.create({
  tabWrapper: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    maxHeight: 28,
  },
  activeTab: {
    borderBottom: `4px solid ${BrandColors.SKY}`,
    paddingBottom: 12,
  },
  inactiveTab: {
    paddingBottom: 16,
  },
  removeAnchorStyling: {
    color: 'inherit',
    textDecoration: 'none',
    ':visited': {
      color: 'inherit',
      textDecoration: 'none',
    },
    ':hover': {
      color: 'inherit',
      textDecoration: 'none',
    },
    ':focus': {
      color: 'inherit',
      textDecoration: 'none',
    },
    ':active': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
});

export const Tab: React.FC<Tab.Props> = ({ id, count, href, active, label, onClick }) => {
  return (
    <a
      id={`it-Tab-${id}-href`}
      data-it="WrapperRef"
      href={href}
      className={css(styles.removeAnchorStyling)}
      data-track-element-name="Tab"
    >
      <div
        data-it="TabWrapper"
        className={css(styles.tabWrapper, active ? styles.activeTab : styles.inactiveTab)}
        id={`it-${id}`}
        onClick={onClick}
      >
        <Header data-it="TabHeader" size={6} colorName={active ? 'NIGHT' : 'NIGHT_60'}>
          {label}
        </Header>
        {count !== undefined && (
          <Tag data-it="CountTag" theme="warning" text={`${count}`} style={{ marginLeft: 3 }} fontWeight="semibold" />
        )}
      </div>
    </a>
  );
};
